import { KeyValueStorageInterface } from 'aws-amplify/utils';

const MEMORY_STORAGE_KEY_PREFIX = '@MemoryStorage:',
  memoryStorage = {};

export class ExpirableStorage implements KeyValueStorageInterface {
  async setItem(key, value) {
    const now = new Date(),
      expiryMillis = 3600000 * 12, // expired in 12 hours
      item = {
        value,
        expiry: now.getTime() + expiryMillis,
      };
    localStorage.setItem(MEMORY_STORAGE_KEY_PREFIX + key, JSON.stringify(item));

    memoryStorage[key] = value;
    return memoryStorage[key];
  }

  async getItem(key) {
    return Object.prototype.hasOwnProperty.call(memoryStorage, key)
      ? memoryStorage[key]
      : undefined;
  }

  async removeItem(key) {
    localStorage.removeItem(MEMORY_STORAGE_KEY_PREFIX + key);
    delete memoryStorage[key];
  }

  async clear() {
    const memoryKeys = await this.getMemoryKeys();
    memoryKeys.forEach((key) => {
      this.removeItem(key);
    });
  }

  private async getMemoryKeys() {
    const keys = Object.keys(localStorage);
    return keys.filter((key) => key.startsWith(MEMORY_STORAGE_KEY_PREFIX));
  }
}
